module.exports = __webpack_public_path__ + "static/media/food-app-3.942de6aa.jpg";